import './Dropdown.css';
import React from 'react';
import Item from './DropdownItem.tsx';

/**
 * TODO make one dropdown class that accepts a typescript param of link and svc array
 */
const Dropdown = (items: Item[]) => {
  return (
    <>
      <div className={'dropdown-content'}>
        {items['items'].map((a) => (
          <a href={a.link} key={a.svc}>
            {a.svc}
          </a>
        ))}
      </div>
    </>
  );
};

export default Dropdown;
